(function ($) {
  $('body').each(function () {
    $(window).on("load", function () {
      $("body").removeClass("preload");
    });
  });
})(jQuery);
